import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { dispatchContactUsEvent } from "@store/Services/AnalyticsService"; // Store Custom Code
import {
    submitContactUsForm,
    SubmitNewAccountContactFormApiParameter,
    submitNewAccountContactUsForm,
} from "@store/Services/EmailService";

type SubmitNewAccountContactFormParameter = {
    emailRecipients?: string;
} & HasOnSuccess;

type HandlerType = ApiHandlerDiscreteParameter<
    SubmitNewAccountContactFormParameter,
    SubmitNewAccountContactFormApiParameter
>;

export const PopulateApiParameter: HandlerType = props => {
    const state = props.getState().components.contactUsForm;
    // Store Custom Code
    // Add country and state, move emailTo to settings
    props.apiParameter = {
        isBusiness: state.fieldValues["isBusiness"],
        fleetSize: state.fieldValues["fleetSize"],
        firstName: state.fieldValues["firstName"],
        lastName: state.fieldValues["lastName"],
        phoneNumber: state.fieldValues["phoneNumber"],
        emailAddress: state.fieldValues["emailAddress"],
        message: state.fieldValues["message"],
        country: state.fieldValues["country"],
        state: state.fieldValues["state"],
        company: state.fieldValues["company"],
        city: state.fieldValues["city"],
    };
};

export const SendDataToApi: HandlerType = async props => {
    await submitNewAccountContactUsForm(props.apiParameter);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    dispatchContactUsEvent(props);
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.();
};

export const chain = [PopulateApiParameter, SendDataToApi, ExecuteOnSuccessCallback];

const submitNewAccountContactForm = createHandlerChainRunner(chain, "SubmitNewAccountContactForm");
export default submitNewAccountContactForm;
